import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbLinkProps,
} from '@chakra-ui/react';
// import { ICONS } from '~/constants';

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbLinkProps[];
};

export const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  return (
    <Breadcrumb
      fontSize="xs"
      fontStyle="italic"
      separator="/"
      // For flex wrapping of inner items
      sx={{
        ol: {
          display: "flex",
          flexWrap: "wrap",
        },
      }}
    >
      {breadcrumbs?.map((breadcrumbLink: BreadcrumbLinkProps, index: number) => (
        <BreadcrumbItem
          key={index}
          color={breadcrumbLink.isCurrentPage ? "blackAlpha.900" : "blackAlpha.700"}
          isCurrentPage={breadcrumbLink.isCurrentPage}
          whiteSpace="nowrap"
          flexShrink="0"
        >
          <BreadcrumbLink
            href={breadcrumbLink.href}
            onClick={breadcrumbLink.onClick}
          >
            {breadcrumbLink['aria-label']}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};
